import React from 'react'
import { useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function NavHead() {
  const navRef = useRef();
  const aboutRef = useRef();
  const navigate = useNavigate();

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  const closeNavbar = () => {
    if (navRef.current.classList.contains("responsive_nav")) {
      showNavbar();
    }
  };

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navigateToWorks = () => {
    navigate("/works");
    closeNavbar();
  };

  return (
    <header className="relative">
      <h3 className="logo">Naresh Eswar</h3>
      <nav ref={navRef} className="subfont">
        {/* Use valid href values or handle clicks appropriately */}
        <a href="/" onClick={closeNavbar}>
          Home
        </a>
        {/* Use Link component for internal navigation */}
        <Link to="/gallery" onClick={closeNavbar}>
          Gallery
        </Link>
        {/* Provide valid href values for scrolling or handle clicks appropriately */}
        <a href="#about" onClick={() => { closeNavbar(); scrollToSection(aboutRef);}}>
          About
        </a>
        {/* Use navigateToWorks instead of closeNavbar for the Portfolio link */}
        <a href="/works" onClick={navigateToWorks}>
          Works
        </a>
        {/* Provide valid href values for scrolling or handle clicks appropriately */}
        <a href="#contact" onClick={closeNavbar}>
          Contact
        </a>
        <button className="nav-btn nav-close-btn" onClick={showNavbar}>
          <FaTimes />
        </button>
      </nav>
      <div>
        <button className="contact border border-black-4 ">
          <a href="#youtube">Youtube</a>
        </button>
        <button className="nav-btn" onClick={showNavbar}>
          <FaBars />
        </button>
      </div>
    </header>
  );
}

export default NavHead;
